import { Component, inject } from '@angular/core';
import { GcButtonComponent, GcTextComponent } from '@ip-only/front-end-library';
import { OfflineKeycloakService } from '../keycloak/service/keycloak.service';
import { CopyStringComponent } from '../shared/copy-string/copy-string.component';
import { FeedbackAlertComponent } from '../shared/feedback-alert/feedback-alert.component';

@Component({
  selector: 'app-missing-roles',
  imports: [
    GcTextComponent,
    GcButtonComponent,
    CopyStringComponent,
    FeedbackAlertComponent,
  ],
  templateUrl: './missing-roles.component.html',
  styleUrl: './missing-roles.component.scss',
})
export class MissingRolesComponent {
  private readonly keycloakService = inject(OfflineKeycloakService);

  logout = () => this.keycloakService.logout();
}
